import React from 'react';
import { LoginBackButton, LoginSubmit } from './LoginControls';

/**
 * Login v2 — "check your inbox" step. Reached after creating an account and
 * whenever `POST /auth/login` refuses an unverified address
 * (`EMAIL_NOT_VERIFIED`). No account is provisioned until the person clicks
 * the link, so the only things to do here are resend it or go back.
 */

interface VerifyEmailStepProps {
  isLoading: boolean;
  /** Seconds left on the client-side resend throttle; 0 = resend available. */
  resendCooldown: number;
  /** Confirmation shown after a successful resend. */
  notice: string;
  onResend: () => void;
  onBack: () => void;
}

export const VerifyEmailStep: React.FC<VerifyEmailStepProps> = ({
  isLoading,
  resendCooldown,
  notice,
  onResend,
  onBack,
}) => (
  <form
    onSubmit={(e) => {
      e.preventDefault();
      onResend();
    }}
    className="flex flex-col"
  >
    {notice && (
      <p role="status" className="mb-[16px] text-body-sm text-ink-secondary">
        {notice}
      </p>
    )}
    <LoginBackButton onClick={onBack} label="Back to sign in" />
    <LoginSubmit loading={isLoading} disabled={resendCooldown > 0}>
      {resendCooldown > 0 ? `Resend link in ${resendCooldown}s` : 'Resend link'}
    </LoginSubmit>
  </form>
);

export default VerifyEmailStep;
